export default __webpack_public_path__ + "static/media/lloyds_business.1c6ed422.png";